export const userHasGroup = (session, group) => {
  const userGroups = session?.accessToken?.payload?.['cognito:groups'] || []
  return userGroups.some(usrGroup => usrGroup === group)
}

export const userHasAnyOfGroups = (session, groups) => {
  return groups.some(group => userHasGroup(session, group))
}
